export default __webpack_public_path__ + "static/media/drone.b4961d67.svg";